import React from "react";
import "./footer.css";
import fenip_logo from "../../assets/images/fenip_logo.png";
import latte_impulse_logo_white from "../../assets/images/latte_impulse_logo_white.png";

import {
  FaFacebookSquare,
  FaYoutubeSquare,
  FaLinkedin,
  FaPhoneSquare,
  FaCircle,
  FaWhatsapp,
  FaEnvelope,
  FaInstagram,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { swadaa_security } from "../../assets";

const Footer = () => {
  return (
    <div className="footer_extWidth">
      <div className="footer_GenFlex">
        <div className="footerSecGen1">
          <div className="footerSecGen1_logo">
            <img src={swadaa_security} alt="oplug_logo" />
          </div>
          {/* <div className="footerSecGen1_heading">
            Discover endless possibilities with Latte Impulse Solutions – your
            trusted partner for quality products and exceptional services.
            Elevate your lifestyle, simplify your shopping experience, and
            unlock new opportunities for growth with us. Join our community
            today and experience the difference.
          </div> */}

          <div className="footerSecGen1_bottomLinks">
            <div className="footerSecGen1_eachbottomLink">Legal notice |</div>
            <div className="footerSecGen1_eachbottomLink">
              Privacy Policy Cookies Policy |
            </div>
            <div className="footerSecGen1_eachbottomLink">
              General Conditions Environmental Policy
            </div>
          </div>

          <div className="footerSecGen1_socialBottom">
            {/* <div className="footerSecGenSocialIcon">
              <a
                href="https://web.facebook.com/profile.php?id=61558437594591"
                target="_blank"
                style={{ textDecoration: "none", color: "#fff" }}
              >
                <FaFacebookSquare />
              </a>
            </div>
       

            <div className="footerSecGenSocialIcon">
              <a
                href="https://www.instagram.com/levit7tjc/"
                target="_blank"
                style={{ textDecoration: "none", color: "#fff" }}
              >
                <FaInstagram />
              </a>
            </div> */}
          </div>
        </div>
        <div className="footerSecGen2">
          {/* <Link
            to="/"
            style={{ textDecoration: "none" }}
            className="footerSecGen2_option"
          >
            <div className="footerSecGen2_bullet">
              <FaCircle />
            </div>

            <div className="footerSecGen2_text">Home</div>
          </Link>

          <Link
            to="/services"
            style={{ textDecoration: "none" }}
            className="footerSecGen2_option"
          >
            <div className="footerSecGen2_bullet">
              <FaCircle />
            </div>
            <div className="footerSecGen2_text">Services</div>
          </Link>

          <Link
            to="/contact"
            style={{ textDecoration: "none" }}
            className="footerSecGen2_option"
          >
            <div className="footerSecGen2_bullet">
              <FaCircle />
            </div>
            <div className="footerSecGen2_text">Contact</div>
          </Link> */}

          {/* <Link
            to="/allproducts"
            style={{ textDecoration: "none" }}
            className="footerSecGen2_option"
          >
            <div className="footerSecGen2_bullet">
              <FaCircle />
            </div>
            <div className="footerSecGen2_text">Products</div>
          </Link> */}
        </div>
        <div className="footerSecGen3">
          <div className="footerSecGen3_offHead">Lagos, Nigeria Office</div>
          <div className="footerSecGen3_offPara">
            1, Balogun Street, Ajegunle, Ikorodu Road, Lagos.
          </div>
          <div className="footerSecGen3_offHead">Regional Office</div>
          <div className="footerSecGen3_offPara">
            Plot 10, Okpanam Road, Ibusa Bypass, Delta State, Nigeria.
          </div>

          <div className="footerSecGen3_contD_phone">
            +234 905 616 9313, +234 706 602 5588
          </div>
          {/* <div>
            <a
              href="tel:+2347066025588"
              style={{ textDecoration: "none" }}
              className="footerSecGen3_contGen"
              target="_blank"
            >
              <div className="footerSecGen3_contIcon">
                <FaPhoneSquare />
              </div>
              <div className="footerSecGen3_contD">+234 706 602 5588</div>
            </a>
            <a
              href="tel:+2349017136001"
              style={{ textDecoration: "none" }}
              className="footerSecGen3_contGen"
              target="_blank"
            >
              <div className="footerSecGen3_contIcon">
                <FaPhoneSquare />
              </div>
              <div className="footerSecGen3_contD">+234 901 713 6001</div>
            </a>
            <a
              href="tel:+2348033538122"
              style={{ textDecoration: "none" }}
              className="footerSecGen3_contGen"
              target="_blank"
            >
              <div className="footerSecGen3_contIcon">
                <FaPhoneSquare />
              </div>
              <div className="footerSecGen3_contD">+234 803 353 8122</div>
            </a>
            <a
              href="tel:+2348026829552"
              style={{ textDecoration: "none" }}
              className="footerSecGen3_contGen"
              target="_blank"
            >
              <div className="footerSecGen3_contIcon">
                <FaPhoneSquare />
              </div>
              <div className="footerSecGen3_contD">+234 802 682 9552</div>
            </a>
          

            <a
              href="mailto: swadaaexpress@gmail.com"
              className="footerSecGen3_contGen"
              target="_blank"
            >
              <div className="footerSecGen3_contIcon">
                <FaEnvelope />
              </div>
              <div className="footerSecGen3_contD">swadaaexpress@gmail.com</div>
            </a>
          </div> */}
        </div>
      </div>

      <div className="footer_right">
        © Copyright 2023 Swadaa Express. All Rights Reserved.
      </div>
    </div>
  );
};

export default Footer;
